import { request } from "../../base";
import type { LeadReminder, ReminderCounts } from "./types";

export const crmRemindersApi = {
	async listReminders(proId: string, leadId: number) {
		return request<LeadReminder[]>(
			`/api/pro/${proId}/crm/leads/${leadId}/reminders`,
		);
	},

	async createReminder(
		proId: string,
		leadId: number,
		data: { title: string; dueAt: number; notes?: string },
	) {
		return request<LeadReminder>(
			`/api/pro/${proId}/crm/leads/${leadId}/reminders`,
			{ method: "POST", body: data },
		);
	},

	async completeReminder(proId: string, reminderId: number) {
		return request<LeadReminder>(
			`/api/pro/${proId}/crm/reminders/${reminderId}/complete`,
			{ method: "PATCH" },
		);
	},

	async dismissReminder(proId: string, reminderId: number) {
		return request<LeadReminder>(
			`/api/pro/${proId}/crm/reminders/${reminderId}/dismiss`,
			{ method: "PATCH" },
		);
	},

	async snoozeReminder(
		proId: string,
		reminderId: number,
		dueAt: number,
	) {
		return request<LeadReminder>(
			`/api/pro/${proId}/crm/reminders/${reminderId}/snooze`,
			{ method: "PATCH", body: { dueAt } },
		);
	},

	async getReminderCounts(proId: string) {
		return request<ReminderCounts>(
			`/api/pro/${proId}/crm/reminder-counts`,
		);
	},
};
